/**
 * PaymentIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PaymentIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M6.5 13h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5" />
    <path
      fillRule="evenodd"
      d="M3.87 5h16.26A1.87 1.87 0 0 1 22 6.87v10.26A1.87 1.87 0 0 1 20.13 19H3.87A1.87 1.87 0 0 1 2 17.13V6.87A1.87 1.87 0 0 1 3.87 5M4 17h16v-6H4zm0-8h16V7H4z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PaymentIcon = makeIcon('PaymentIcon', PaymentIconSvg)
